import React from 'react'
import classNames from 'classnames'
import { HeadingProps } from './Heading.d'
import ConditionalWrapper from '../../atoms/ConditionalWrapper/ConditionalWrapper'

const Heading = ({
  allowHtml,
  as,
  classes,
  color,
  content,
  fontFamily,
  fontSize,
  fontWeight,
  heading = 'h1',
  hoverEffect,
  id,
  // todo - update this leading prop to be null
  // We should be using the line height assigned for each heading value by default, not none
  leading = 'leading-none',
  letterSpacing,
  textAlign = ['text-left'],
  width
}: HeadingProps) => {
  const Element = as ? as : heading

  const weightClass = fontWeight ? fontWeight : false
  const fontSizeClass = fontSize ? fontSize.join(' ') : false
  const leadingClass = leading ? leading : false
  const fontFamilyClass = fontFamily ? fontFamily : false
  const colorClass = color !== undefined ? color.join(' ') : ''
  const textAlignClass = textAlign !== undefined ? textAlign.join(' ') : ''

  const headingClasses = classNames(
    classes,
    {
      [`${fontSizeClass ? fontSizeClass : 'text-[45px] md:text-[64px]'} ${
        leadingClass ? leadingClass : 'leading-[48px] md:leading-[72px]'
      } ${weightClass ? weightClass : 'font-medium'} ${
        fontFamilyClass ? fontFamilyClass : 'font-effra'
      }`]: heading === 'h1'
    },
    {
      [`${fontSizeClass ? fontSizeClass : 'text-[31px] md:text-[45px]'} ${
        leadingClass ? leadingClass : 'leading-[40px] md:leading-[48px]'
      } ${weightClass ? weightClass : 'font-medium'} ${
        fontFamilyClass ? fontFamilyClass : 'font-effra'
      }`]: heading === 'h2'
    },
    {
      [`${fontSizeClass ? fontSizeClass : 'text-[26px] md:text-[31px]'} ${
        leadingClass ? leadingClass : 'leading-[32px] md:leading-[40px]'
      } ${weightClass ? weightClass : 'font-normal md:font-medium'} ${
        fontFamilyClass ? fontFamilyClass : 'font-effra'
      }`]: heading === 'h3'
    },
    {
      [`${fontSizeClass ? fontSizeClass : 'text-[22px] md:text-[26px]'} ${
        leadingClass ? leadingClass : 'leading-[32px]'
      } ${weightClass ? weightClass : 'font-normal'} ${
        fontFamilyClass ? fontFamilyClass : 'font-effra'
      }`]: heading === 'h4'
    },
    {
      [`${fontSizeClass ? fontSizeClass : 'text-base md:text-[22px]'} ${
        leadingClass ? leadingClass : 'leading-[24px] md:leading-[32px]'
      } ${weightClass ? weightClass : 'font-semibold'} ${
        fontFamilyClass ? fontFamilyClass : 'font-effra'
      }`]: heading === 'h5'
    },
    colorClass,
    { [letterSpacing]: letterSpacing },
    textAlignClass,
    { [hoverEffect]: hoverEffect },
    { [width]: width }
  )

  const hoverClasses = classNames({
    'relative w-auto bg-gradient-to-r from-default to-default bg-[length:0px_10%] bg-no-repeat bg-[0px_bottom] py-[0.1%] px-0 transition-[background-size] ease-[cubic-bezier(0.785, 0.135, 0.15, 0.86)] duration-[400ms] delay-0 hover:bg-[length:100%_10%] group-hover:bg-[length:100%_10%]':
      hoverEffect === 'headline__underline',
    'relative w-auto bg-gradient-to-r from-[#4c4c4c] to-[#4c4c4c] bg-[length:0px_10%] bg-no-repeat bg-[0px_bottom] py-[0.1%] px-0 transition-[background-size] ease-[cubic-bezier(0.785, 0.135, 0.15, 0.86)] duration-[400ms] delay-0 hover:bg-[length:100%_10%] group-hover:bg-[length:100%_10%]':
      hoverEffect === 'headline__underline-grey',
    'group-hover:text-otl-orange': hoverEffect === 'headline__text-otl-orange',
    'after:content-icon-arrow-forward-black after:opacity-0 group-hover:after:opacity-100 after:-translate-x-1 group-hover:after:-translate-x-0 inline-flex items-center after:h-[32px] after:transition-transform after:ease-in after:duration-[300ms]':
      hoverEffect === 'arrow'
  })
  return (
    <Element className={`${headingClasses}`} data-testid='Heading' id={id}>
      <ConditionalWrapper
        condition={hoverEffect}
        wrapper={(children) => <span className={hoverClasses}>{children}</span>}
      >
        {allowHtml ? (
          <span dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          content
        )}
      </ConditionalWrapper>
    </Element>
  )
}

export default Heading
